import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as constants from './payment.constants';
import * as types from './payment.types';

export const storePayment = generateStoreResourceAction<types.IPayment>(constants.STORE_PAYMENT);
export const clearPayment = generateClearResourceAction(constants.CLEAR_PAYMENT);
